// @flow
import React from 'react';
import styled from 'styled-components';
import Check from 'AssetsRoot/images/homie_v3/check.svg.react';
import * as Layout from 'styles/Layout';
import classNames from 'classnames';
import OptionList from 'models/OptionList';

const Container = styled(Layout.FlexRow)`
  align-items: center;
  position: relative;
  height: 35px;
  width: 100%;
  border: 1px solid #ececec;
  border-radius: 2px;
  background-color: #ffffff;
  margin-bottom: 20px;
  padding: ${props => (props.padding ? props.padding : '0 18px')};
  &:hover {
    background-color: #f2f1f1;
  }
  &:focus {
    background-color: #fff;
  }
  ${props => props.hasError && 'border-color: #dc3545;'}
`;
const Box = styled.div`
  position: relative;
  height: 18px;
  width: 18px;
  margin-right: ${props => (props.margin ? props.margin : '18px')};
  border: 2px solid ${props => props.color || '#278C7E'};
  border-radius: 2px;
  background-color: #fff;
  transition: all 0.2s linear;
  &.checked {
    background-color: ${props => props.color || '#278C7E'};
  }
`;

const CheckIcon = styled(Check)`
  width: 20px;
  height: 20px;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  transform: scale(0.5);
  transform-origin: 25% 5px;
  opacity: 0;
  transition: all 0.2s linear;
  &.visible {
    opacity: 1;
  }
`;

const OptionText = styled.span`
  min-height: 19px;
  font-size: 16px;
  line-height: 19px;
`;
const CheckBoxInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  opacity: 0;
  cursor: pointer;
`;

const ErrorMessage = styled.span.attrs({
  className: 'error-message'
})`
  display: block;
  overflow: hidden;
  height: ${props => (props.visible ? '15px' : '0')};
  color: #ff1a00;
  font-size: 14px;
  line-height: 15px;
  transition: all 0.2s linear;
  margin-top: ${props => (props.visible ? '-10px' : '0')};
  margin-bottom: ${props => (props.visible ? '20px' : '0')};
`;

type PropsType = {
  options: Array<OptionList>,
  name: string,
  value: [],
  isValidated?: boolean,
  centerButton?: any,
  saving?: Boolean,
  color?: String,
  disabledFields?: [],
  onValueChange: (value: string | Array<string>, input: string) => void
};
type StateType = {
  inputValue: [],
  isTouched: boolean
};

export default class CheckOptionFormComponent extends React.Component<
  PropsType,
  StateType
> {
  state = {
    inputValue: this.props.value,
    isTouched: false
  };

  handleChange = ({ target }: any): void => {
    const { name } = this.props;
    const inputValue = target.value;
    let arrayValues = JSON.parse(JSON.stringify(this.state.inputValue));
    if (this.existInArray(inputValue)) {
      arrayValues = arrayValues.filter(function(value) {
        return value !== inputValue;
      });
    } else {
      arrayValues.push(inputValue);
    }
    this.setState({ inputValue: arrayValues });
    this.setState({ isTouched: true });
    this.props.onValueChange(arrayValues, name);
  };

  existInArray = (value: any): boolean => {
    let existInArray = false;
    for (const item of this.state.inputValue) {
      if (item === value) {
        existInArray = true;
        break;
      }
    }
    return existInArray;
  };

  ErrorMessage = () => {
    const { inputValue } = this.state;
    if (inputValue.length == 0) {
      return (
        <ErrorMessage visible={true}>
          Debe seleccionar al menos una opción
        </ErrorMessage>
      );
    }
  };

  hasValidationErrors = (): boolean => {
    const { isValidated, saving } = this.props;
    const { inputValue, isTouched } = this.state;
    return isValidated && inputValue == 0 && (isTouched || saving);
  };

  isDisabled = (idOption): boolean => {
    const { disabledFields } = this.props;

    if (!disabledFields) return false;

    return disabledFields.includes(idOption);
  };

  render() {
    const { name, options, color } = this.props;

    return (
      <Layout.FlexColumn>
        {options.map((option, index) => (
          <Container
            key={index}
            hasError={this.hasValidationErrors()}
            className={this.hasValidationErrors() ? 'error-message' : ''}
          >
            <Box
              className={this.existInArray(option.id) ? 'checked' : ''}
              color={color}
            >
              <CheckIcon
                className={this.existInArray(option.id) ? 'visible' : ''}
              />
            </Box>
            <OptionText>{option.text}</OptionText>
            <CheckBoxInput
              name={name}
              id={option.id}
              type="checkbox"
              value={option.id}
              checked={this.existInArray(option.id)}
              onChange={this.handleChange}
              className={classNames('radio-button')}
              disabled={this.isDisabled(option.id)}
            />
          </Container>
        ))}
        {this.hasValidationErrors() && this.ErrorMessage()}
      </Layout.FlexColumn>
    );
  }
}
